import React from 'react';
import { Button } from 'antd';
const WikiActionView = () => {
  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <Button className='apphome-display-btn'>Find</Button>
      <Button className='apphome-display-btn'>Add to Confluence</Button>
      <Button className='apphome-display-btn'>Update Confluence</Button>
    </div>
  );
};

export default WikiActionView;
